module.exports = __webpack_public_path__ + "img/moose_C.33b12ba6.jpg";